export default (blob, {name = 'file.pdf', mime = 'application/pdf'} = {}) =>
  new File([blob], name, {type: mime});
